import JointCommissions from './JointCommissions';

export default JointCommissions;
